exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-markdown-remark-frontmatter-path-jsx": () => import("./../../../src/pages/{markdownRemark.frontmatter__path}.jsx" /* webpackChunkName: "component---src-pages-markdown-remark-frontmatter-path-jsx" */)
}

